import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  // Access the Angular Router using inject()
  private router = inject(Router);

  /**
   * Navigates directly to a given URL.
   * @param url The target URL as a string (absolute or relative)
   */
  navigateTo(url: string): void {
    this.router.navigateByUrl(url);
  }

  /**
   * Navigates to a URL and appends path segments.
   * @param url The base URL or route
   * @param pathParams Array of path segments to append
   */
  navigateWithParams(url: string, pathParams: string[]): void {
    this.router.navigate([url, ...pathParams]);
  }

  /**
   * Navigates to a URL with query parameters.
   * @param url The base URL or route
   * @param queryParams An object containing query parameters
   */
  navigateWithQueryParams(url: string, queryParams: Record<string, any>): void {
    this.router.navigate([url], { queryParams });
  }
}
